export type QuoteMagicProgressBarProps = {
  percentage: number;
  stepName: string;
};

export type PhraseCategory = 'beginning' | 'middle' | 'end';

export const Phrases: Record<PhraseCategory, string[]> = {
  beginning: [
    'Every great quest begins like this',
    "You're on your way to adventure!",
    'Step forward. Your adventure awaits!',
    'All great quests starts small.',
  ],
  middle: [
    'Onward! You’re getting closer.',
    'The hard part is behind you.',
    'You’ve mastered this chapter!',
    'Ah yes… excellent progress.',
    'The magic is working.',
    'I see the path taking shape.',
    'Your choices shape the outcome.',
    'Each step brings more clarity.',
  ],
  end: [
    'Your quest is nearly complete.',
    'Just a final touch remains.',
    'Finish strong. I’ve got the rest.',
    'The outcome is almost revealed.',
    'Just a few steps remain.',
    'You’re almost at the end of the path.',
  ],
};
